import React from 'react';
import Layout from '../../shared/components/Layout';
import Complete from '@/components/Complete';

const FacilityLensComplete: React.FC = () => {
  return (
    <React.Fragment>
      <Layout>
        <Complete id="page-facility_login" heading="施設型定額制レンズ注文完了" content="施設型定額制レンズの注文が完了しました。"  />
      </Layout>
    </React.Fragment>
  )
}

export default FacilityLensComplete;